module.exports = __webpack_public_path__ + "img/course3.4707a798.png";